import React, { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import ImageUploading from 'react-images-uploading';
import {
    resetReceipt, prepReceipt, analyzeReceipt, validationReceiptError,
    resetUploadReceipt, resetCaptureReceipt
} from '../redux/receipt';
import { setEntry } from '../redux/entry';
import { ENTRY_TYPE_EXPENSE } from '../config/staticValues';

const ReceiptUpload = () => {
    const dispatch = useDispatch();
    const { receipt: receiptFromStore, openUploadReceipt, openCaptureReceipt } = useSelector((state) => state.receipt);
    const entryId = useSelector((state) => state.entry?.id);
    const timecardId = useSelector((state) => state.general.timecardId);
    const [receipts, setReceipts] = useState([]);
    const uploadRef = useRef(null);// for selecting a file
    const captureRef = useRef(null);// for forcing a camera capture, specifically for Android

    useEffect(() => {
        setReceipts(receiptFromStore ? [receiptFromStore] : []);
    }, [receiptFromStore]);
    useEffect(() => {
        if (openUploadReceipt) {
            uploadRef.current?.onImageUpload?.();
            dispatch(resetUploadReceipt());
        } else if (openCaptureReceipt) {
            captureRef.current?.onImageUpload?.();
            dispatch(resetCaptureReceipt());
        }
    }, [openUploadReceipt, openCaptureReceipt, dispatch]);

    const onChange = async (receiptList) => {
        setReceipts(receiptList);
        if (receiptList.length > 0) {
            dispatch(prepReceipt(receiptList[0]));
            openForm();
            dispatch(analyzeReceipt(receiptList[0]));
        } else {
            dispatch(resetReceipt());
        }
    };
    const openForm = () => {
        if (!entryId) {
            dispatch(setEntry({
                id: -1,
                type: ENTRY_TYPE_EXPENSE,
                timecardId: timecardId,
                noCharge: false,
                payBonus: true,
            }));
        }
    };
    const onError = (errors, files) => {
        if (errors.maxFileSize) {// there are other error types, but we are only setting a limit on file size
            dispatch(validationReceiptError("File is too large. Max size is 5MB."));
            openForm();// open form to show the error
        }
    };

    return (
        <div id='post2-receiptUpload'>
            <ImageUploading
                value={receipts}
                onChange={onChange}
                onError={onError}
                maxFileSize={5000000}// 5MB
                //dataURLKey="data_url"
                allowNonImageType={true}
                //acceptType={["jpg", "jpeg", "png", "pdf"]}
                multiple={false}
                inputProps={{
                    accept: "image/*,application/pdf",
                }}
            >
                {({ onImageUpload }) => {
                    uploadRef.current = { onImageUpload };
                }}
            </ImageUploading>
            <ImageUploading
                value={receipts}
                onChange={onChange}
                onError={onError}
                maxFileSize={5000000}
                allowNonImageType={true}
                multiple={false}
                inputProps={{
                    accept: "image/*,application/pdf",
                    capture: "environment", // use "user" for front-facing camera
                }}
            >
                {({ onImageUpload }) => {
                    captureRef.current = { onImageUpload };
                }}
            </ImageUploading>
        </div>
    );
};

export default ReceiptUpload;
